import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
import { FretDivider } from './components/Ornaments';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-6 text-center" data-id="element-0" data-mp="2wiyv4mpflj91">
    <FretDivider character="次" data-id="element-1" data-mp="28u5yeo0zj7dd" />
    <p className="mt-4 font-display text-xl font-bold italic leading-relaxed text-brand-burgundy/90 md:text-3xl" data-id="element-2" data-mp="28te2fc3h77mk">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="rice-paper min-h-screen font-sans text-brand-text selection:bg-brand-burgundy/20 selection:text-brand-burgundyDark" data-id="element-3" data-mp="3ijfwm41bw4gq">
      <UrgencyBanner data-id="element-4" data-mp="3mj6lu3b7icj5" />
      <Hero data-id="element-5" data-mp="3rbrakqf99zft" />
      <PackContents data-id="element-6" data-mp="3rbzq6q2rjiup" />
      <InitialTestimonials data-id="element-7" data-mp="3rcsy3udgkeef" />
      <PainPoints data-id="element-8" data-mp="3reltgdimfc74" />
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-9" data-mp="5otf64sd496">
        <Pricing data-id="element-10" data-mp="82k72sfnuax" />
      </div>
      <MoreTestimonials data-id="element-11" data-mp="2zld2jatxbhc2" />
      <Guarantee data-id="element-12" data-mp="2zm4ywnvchj3e" />
      <FAQ data-id="element-13" data-mp="2zmo3z3zwcd00" />
      <CostComparison data-id="element-14" data-mp="2zmwhmy3ufmc9" />
      <TransitionPhrase data-id="element-15" data-mp="33mou3lwcycmw" />
      <EmotionalClose data-id="element-16" data-mp="33m5eibu6k0c1" />
      <Footer data-id="element-17" data-mp="33ngee0ki8nxv" />
      <FloatingNotification data-id="element-18" data-mp="33mym1f0yqtv8" />
    </div>;
}